import React, {Fragment, useEffect, useState} from 'react';

import '../../../App.css';
import {useAppDispatch, useAppSelector} from "../../../feature/tools";
import {Avatar, Button, Dropdown, Flex, Input, MenuProps, Modal, Space, Table, TableProps, Tag} from "antd";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faAngleDown, faEllipsisVertical} from "@fortawesome/free-solid-svg-icons";
import {Status} from "../../../feature/project/status";
import {
    deleteContributor,
    fetchContributors,
    inviteContributor,
    updateContributor
} from "../../../feature/project/userSlice";
import {User} from "../../../feature/project/User";
import {MenuItemType} from "antd/es/menu/interface";
import SimpleDivider from "../../../components/SimpleDivider";
import Title from "antd/es/typography/Title";

const ProjectMembersSettings = (
    props: {
        saveFunction: (saveFunction: () => void) => void
    }
) => {
    const dispatch = useAppDispatch()
    const [deleteConfirmation, setDeleteConfirmation] = useState(false);
    const [member, setMember] = useState<User>();
    const [loaded, setLoaded] = useState(false);
    const [invitationEmail, setInvitationEmail] = useState('');
    const [emailValid, setEmailValid] = useState(true);
    const [invitationRole, setInvitationRole] = useState('Viewer');
    const loadingStatus = useAppSelector(state => state.users.status)
    const contributors = useAppSelector(state => state.users.contributors)
    const project = useAppSelector(state => state.projects.project)
    const user = useAppSelector(state => state.users.currentUser)

    useEffect(() => {
        if (loadingStatus === Status.Idle || !loaded) {
            dispatch(fetchContributors(project?.id))
            setLoaded(true)
        }
    }, [project, loadingStatus, dispatch])

    const columns: TableProps<User>['columns'] = [
        {
            title: 'avatar',
            dataIndex: 'avatar',
            key: '0',
            render: (avatar) => <Avatar src={avatar}/>
        },
        {
            title: 'email',
            dataIndex: 'email',
            key: '1',
        },
        {
            title: 'role',
            dataIndex: '',
            key: '2',
            render: (contributor) => {
                const handleRoleClick: MenuProps['onClick'] = (e) => {
                    dispatch(updateContributor({
                        projectId: project?.id || 0,
                        userId: contributor.id,
                        role: e.key.toLowerCase(),
                        status: contributor.status
                    }))
                };

                const roles: MenuItemType[] = (["Owner", "Editor", "Viewer"]).map(
                    (role: string) => ({
                        label: role,
                        key: role,
                    })
                );

                const rolesMenu = {
                    items: roles,
                    onClick: handleRoleClick,
                };


                return (
                    user?.role === 'owner' || user?.role === 'creator' ?
                        contributor?.role == 'creator' ? <div style={{padding:8}}>Creator</div> :<Dropdown menu={rolesMenu} trigger={["click"]}>
                            <Button style={{
                                width: '100%',
                                padding: '8px',
                            }} type={'text'}>
                                <Flex justify={'space-between'} gap={16} align={'center'} style={{width: '100%'}}>
                                    {contributor.role.charAt(0).toUpperCase() + contributor.role.slice(1)}
                                    <FontAwesomeIcon icon={faAngleDown}/>
                                </Flex>
                            </Button>

                        </Dropdown> : <div style={{
                            textAlign: 'center',
                            width: '100%',
                            padding: '8px',
                        }}>{contributor.role.charAt(0).toUpperCase() + contributor.role.slice(1)}</div>)
            }
        },
        {
            title: 'status',
            dataIndex: 'status',
            key: '3',
            render: (status: string) => <Tag
                color={status === 'active' ? 'green' : status === 'invited' ? 'blue' : 'red'}>{status.charAt(0).toUpperCase() + status.slice(1)}</Tag>
        },
        {
            title: 'action',
            dataIndex: '',
            key: '4',
            render: (contributor) => {
                const availableActions = contributor.status === 'active' ? ["Deactivate", "Delete"] : contributor.status === 'invited' ? ["Delete"] : ["Activate", "Delete"];

                const handleActionClick: MenuProps['onClick'] = (e) => {
                    if (e.key === 'Delete') {
                        setMember(contributor)
                        setDeleteConfirmation(true)
                    }
                    if (e.key === 'Activate') {
                        dispatch(updateContributor({
                            projectId: project?.id || 0,
                            userId: contributor.id,
                            role: contributor.role,
                            status: 'active'
                        }))
                    }
                    if (e.key === 'Deactivate') {
                        dispatch(updateContributor({
                            projectId: project?.id || 0,
                            userId: contributor.id,
                            role: contributor.role,
                            status: 'inactive'
                        }))
                    }
                };

                const actions: MenuItemType[] = (availableActions).map(
                    (action: string) => ({
                        label: action,
                        key: action,
                        danger: action === 'Delete'
                    })
                );

                const actionsMenu = {
                    items: actions,
                    onClick: handleActionClick,
                };

                return (contributor?.role !== 'creator' && ((user?.role === 'owner' && user?.id != contributor?.id) || user?.role === 'creator')  ?
                    <Dropdown menu={actionsMenu} trigger={["click"]} placement={'bottomRight'}>
                        <Button type={'text'}>
                            <FontAwesomeIcon icon={faEllipsisVertical}/>
                        </Button>
                    </Dropdown> : '')
            }
        },
    ]

    const roles: MenuItemType[] = (["Owner", "Editor", "Viewer"]).map(
        (role: string) => ({
            label: role,
            key: role,
        })
    );

    const handleRoleClick: MenuProps['onClick'] = (e) => {
        setInvitationRole(e.key)
    };

    const rolesMenu = {
        items: roles,
        onClick: handleRoleClick,
    };

    const validateEmail = (email: string) => {
        const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        setEmailValid(
            re.test(email.toLowerCase())
        )
    };

    return (
        <Fragment>
            <Flex justify={'center'} align={'top'}
                  style={{overflowY: 'auto', scrollbarWidth: "none", overflowX: 'hidden'}}>
                <Space direction={'vertical'} style={{width: '100%'}} size={20}>
                    <Title level={5} style={{margin: 0, paddingTop: 10}}>Members</Title>
                    {user?.role === 'owner' || user?.role === 'creator' ?
                        <Flex justify={'center'}>
                            <Space style={{
                                width: '100%',
                                padding: 32,
                                background: '#fff3d0',
                                borderRadius: 6
                            }}>
                                Invite a new member
                                <Input status={emailValid ? '' : "error"} onBlur={() => validateEmail(invitationEmail)}
                                       type={'email'}
                                       placeholder={'E-mail address'} style={{width: 200}}
                                       value={invitationEmail} onChange={(e) => setInvitationEmail((e.target.value))}/>
                                <Dropdown menu={rolesMenu} trigger={["click"]}>
                                    <Button style={{
                                        width: '100%',
                                    }} type={'default'}>
                                        <Flex justify={'space-between'} gap={16} align={'center'}>
                                            {invitationRole}
                                            <FontAwesomeIcon icon={faAngleDown}/>
                                        </Flex>
                                    </Button>

                                </Dropdown>
                                <Button type={'primary'} onClick={() => {
                                    dispatch(inviteContributor({
                                        projectId: project?.id || 0,
                                        email: invitationEmail,
                                        role: invitationRole.toLowerCase(),
                                    }))
                                    setInvitationEmail('')
                                    setInvitationRole('Viewer')
                                }
                                } disabled={!emailValid}>Invite</Button>
                            </Space>
                        </Flex> : ''}
                    <div>
                        <SimpleDivider/>
                        <Table pagination={false}
                               showHeader={false}
                               columns={columns}
                               dataSource={contributors}
                               rowKey={(user) => user.email}/>
                    </div>
                </Space>
            </Flex>
            <Modal
                title="Delete member"
                open={deleteConfirmation}
                onOk={() => {
                    setDeleteConfirmation(false)
                    dispatch(deleteContributor({
                        projectId: project?.id || 0,
                        userId: member?.id || 0,
                        role: '',
                        status: ''
                    }))
                }}
                onCancel={() => setDeleteConfirmation(false)}
                okText="Delete"
                cancelText="Cancel"
                okType='danger'
            >
                {`Are you sure you want to delete this member ${member?.email || ''}?`}
            </Modal>
        </Fragment>
    );
};

export default ProjectMembersSettings;